import { createContext, useContext } from "react";

export const UserContext = createContext(null);

export const useCurrentUser = () => {
  const context = useContext(UserContext);
  return context?.user || null;
};

export const useRefreshUser = () => {
  const context = useContext(UserContext);
  return context?.refreshUser || (() => {});
};
